<script>
import DropdownItem from 'element-ui/lib/dropdown-item';

export default DropdownItem;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/dropdown-item.css';
// @import "../../stylesheets/utils/utils";
</style>
